import { emptyClientProduct } from 'pages/ProductManagement/consts';
import { NON_VISIBLE_FIELDS } from 'shared/const';

/**
 * It takes an array of products, and for each product, it takes the key/value from the
 * "other" object and adds them to the product object
 * @param {any} products - any - this is the array of products that you want to process
 * @returns An array of objects with the key other removed.
 */
const processOtherColumn = (products: any) => {
    return products.map((product: any) => {
        let newProduct: any = { ...product };

        if (newProduct.other) {
            Object.keys(newProduct.other).map((key) => {
                newProduct[key] = newProduct.other[key];
            });

            delete newProduct.other;
        }

        return newProduct;
    });
};

const isCustomField = (field: string) => {
    return emptyClientProduct[field] == null && !NON_VISIBLE_FIELDS.includes(field) && !field.includes('name_');
};

export { processOtherColumn, isCustomField };
